import type { TeamRole } from '../types';

export function canInviteMembers(role: TeamRole | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

export function canRemoveMember(
  callerRole: TeamRole | undefined,
  targetRole: TeamRole,
  isSelf: boolean
): boolean {
  if (isSelf) return false;
  if (callerRole === 'owner') return true;
  if (callerRole === 'admin') return targetRole === 'member';
  return false;
}

export function canChangeRole(callerRole: TeamRole | undefined, isSelf: boolean): boolean {
  return callerRole === 'owner' && !isSelf;
}

export function canDeleteTeam(role: TeamRole | undefined): boolean {
  return role === 'owner';
}

export function canEditTeamProfile(role: TeamRole | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

export function canAccessTeamSettings(role: TeamRole | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

export function canTransferOwnership(role: TeamRole | undefined): boolean {
  return role === 'owner';
}

/** Promote/demote ladder only — ownership uses transferOwnership. */
export function getAvailableRoleChanges(
  callerRole: TeamRole | undefined,
  targetRole: TeamRole
): TeamRole[] {
  if (callerRole !== 'owner') return [];
  if (targetRole === 'member') return ['admin'];
  if (targetRole === 'admin') return ['member'];
  return [];
}

export function canLeaveTeam(role: TeamRole | undefined, memberCount: number): boolean {
  if (role === 'owner' && memberCount > 1) return false;
  return true;
}

export function isMemberCollectionVisible(shareCollection: boolean | undefined): boolean {
  return shareCollection === true;
}
